import z from 'zod';
import { RoutingRuleTriggerType } from '@mews-commander/data-access';

export enum RoutingRulesListFilterSchemaKeys {
    Name = 'name',
    Timing = 'timing',
    Company = 'company',
    TravelAgency = 'travelAgency',
}

export const routingRulesListFilterSchema = z
    .object({
        [RoutingRulesListFilterSchemaKeys.Name]: z.string(),
        [RoutingRulesListFilterSchemaKeys.Timing]: z.array(z.nativeEnum(RoutingRuleTriggerType)).min(1),
        [RoutingRulesListFilterSchemaKeys.Company]: z.string().nullable(),
        [RoutingRulesListFilterSchemaKeys.TravelAgency]: z.string().nullable(),
    })
    .partial();

export const routingRulesListUrlFilterSchema = z.optional(routingRulesListFilterSchema);

export type RoutingRulesListFilterValues = z.infer<typeof routingRulesListFilterSchema>;
